import { useCallback, useState } from 'react';

interface UseShowOnceProps {
  flag: string;
  userId: number;
}

interface UseShowOnce {
  hasBeenSeen: boolean;
  setAsSeen: () => void;
}

/**
 * Generate the localStorage key for a show-once feature
 */
export const getShowOnceKey = (flag: string, userId: number): string =>
  `hb-show-once-${flag}[${userId}]`;

/**
 * Check if a feature has been seen by reading from localStorage
 */
export const hasBeenSeen = (flag: string, userId: number): boolean =>
  !!localStorage.getItem(getShowOnceKey(flag, userId));

const useShowOnce = ({ userId, flag }: UseShowOnceProps): UseShowOnce => {
  const key = getShowOnceKey(flag, userId);

  const [hasBeenSeenState, setHasBeenSeenState] = useState(
    !!localStorage.getItem(key),
  );

  const setAsSeen = useCallback(() => {
    localStorage.setItem(key, 'true');
    setHasBeenSeenState(true);
  }, [key]);

  return {
    hasBeenSeen: hasBeenSeenState,
    setAsSeen,
  };
};

export { useShowOnce };
export type { UseShowOnce };
